var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdUnits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.5C3.78717 7.5 3.609 7.42817 3.4655 7.2845C3.32183 7.141 3.25 6.96283 3.25 6.75C3.25 6.53717 3.32183 6.359 3.4655 6.2155C3.609 6.07183 3.78717 6 4 6H10C10.2128 6 10.391 6.07183 10.5345 6.2155C10.6782 6.359 10.75 6.53717 10.75 6.75C10.75 6.96283 10.6782 7.141 10.5345 7.2845C10.391 7.42817 10.2128 7.5 10 7.5H4ZM2.30775 21.5C1.80258 21.5 1.375 21.325 1.025 20.975C0.675 20.625 0.5 20.1974 0.5 19.6923V2.30775C0.5 1.80258 0.675 1.375 1.025 1.025C1.375 0.675 1.80258 0.5 2.30775 0.5H11.6923C12.1974 0.5 12.625 0.675 12.975 1.025C13.325 1.375 13.5 1.80258 13.5 2.30775V19.6923C13.5 20.1974 13.325 20.625 12.975 20.975C12.625 21.325 12.1974 21.5 11.6923 21.5H2.30775ZM2 18.75V19.6923C2 19.7693 2.03208 19.8398 2.09625 19.9038C2.16025 19.9679 2.23075 20 2.30775 20H11.6923C11.7692 20 11.8398 19.9679 11.9038 19.9038C11.9679 19.8398 12 19.7693 12 19.6923V18.75H2ZM2 17.25H12V4.75H2V17.25ZM2 3.25H12V2.30775C12 2.23075 11.9679 2.16025 11.9038 2.09625C11.8398 2.03208 11.7692 2 11.6923 2H2.30775C2.23075 2 2.16025 2.03208 2.09625 2.09625C2.03208 2.16025 2 2.23075 2 2.30775V3.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdUnits);
export default __webpack_public_path__ + "static/media/ad_units.80b3d846bfa335c070f5449de1dc2c79.svg";
export { ForwardRef as ReactComponent };